import { Component, Input } from '@angular/core';

@Component({
    selector: 'casing-plan-information-gis-modal',
    templateUrl: './casing-plan-information.component.html',
    styleUrls: ['./casing-plan-information.component.scss'],
    standalone: false
})
export class CasingPlanInformationComponent {
    @Input()
    casingPlan: any;
}
